export default [
  {
    name: 'getSysConfig',
    method: 'GET',
    path: '/vue/system/sysconfig-get'
  },
  {
    name: 'getSysConfigList',
    method: 'POST',
    path: '/vue/system/sysconfig-page'
  },
  {
    name: 'saveSysConfig',
    method: 'POST',
    path: '/vue/system/sysconfig-save'
  },
  {
    name: 'deleteSysConfig',
    method: 'POST',
    path: '/vue/system/sysconfig-delete'
  }
];
